import { isMobile, isTablet } from "react-device-detect";
import { isPhone } from "../../../constants/env";
import classes from "./content.module.css";

export function ContentVisualizer(props: { content: string }) {
  return (
    <div className="flex justify-center">
      <div dangerouslySetInnerHTML={{ __html: props.content }}></div>
      {/*  {isPhone && (*/}
      {/*    <div*/}
      {/*      dangerouslySetInnerHTML={{ __html: props.content }}*/}
      {/*      className="*/}
      {/*      dark-text*/}
      {/*      prose-p:!text-start*/}
      {/*      prose-li:!text-start*/}
      {/*      w-[90vw]*/}
      {/*      xs:prose-lg*/}
      {/*      md:prose-xl*/}
      {/*      !lg:prose*/}
      {/*      prose-slate*/}
      {/*      dark:prose-invert*/}
      {/*       prose-img:max-w-[90vw]*/}
      {/*       prose-img:max-h-[300px]*/}
      {/*       prose-img:object-scale-down*/}
      {/*      prose-blockquote:!text-xl*/}
      {/*      prose-blockquote:text-gray-600*/}
      {/*      prose-blockquote:italic*/}
      {/*      dark:prose-blockquote:text-gray-500*/}
      {/*      prose-blockquote:font-semibold*/}
      {/*      dark:prose-h3:!text-gray-200*/}
      {/*    dark:prose-p:!text-gray-200*/}
      {/*     dark:prose-h4:!text-gray-200*/}
      {/*    prose-p:!p-0*/}
      {/*    "*/}
      {/*    />*/}
      {/*  )}*/}
      {/*  {isTablet && (*/}
      {/*    <div*/}
      {/*      dangerouslySetInnerHTML={{ __html: props.content }}*/}
      {/*      className="max-w-none xs:prose-lg md:prose-xl*/}
      {/*      dark-text*/}
      {/*      lg:prose-2xl prose-slate dark:prose-invert*/}
      {/*    prose-img:max-w-[90vw] prose-img:max-h-[25rem] prose-img:object-cover*/}
      {/*    prose-blockquote:!text-3xl prose-blockquote:text-gray-600  dark:prose-blockquote:text-gray-500  prose-blockquote:font-semibold*/}
      {/*                 dark:prose-h3:!text-gray-200*/}
      {/*    dark:prose-p:!text-gray-200*/}
      {/*     dark:prose-h4:!text-gray-200*/}
      {/*\prose-p:!p-0*/}

      {/* "*/}
      {/*    />*/}
      {/*  )}*/}
      {/*  {!isMobile && (*/}
      {/*    <div className={`${classes.proseDiv}`}>*/}
      {/*      <div*/}
      {/*        dangerouslySetInnerHTML={{ __html: props.content }}*/}
      {/*        className={`*/}
      {/*    prose*/}
      {/*    dark-text*/}
      {/*    xs:prose-lg*/}
      {/*    lg:max-w-6xl*/}
      {/*    md:prose-xl*/}
      {/*    !lg:prose-md*/}
      {/*    dark:prose-invert*/}
      {/*    dark:prose-h3:!text-gray-200*/}
      {/*    dark:prose-h4:!text-gray-200*/}
      {/*    dark:prose-p:!text-gray-200 */}
      {/*    dark:prose-span:!text-gray-200*/}
      {/*    dark:prose-stone:!text-gray-200*/}
      {/*    prose-blockquote:!text-2xl*/}
      {/*    prose-blockquote:text-gray-600*/}
      {/*    dark:prose-blockquote:text-gray-200*/}
      {/*    prose-blockquote:font-semibold */}
      {/*    prose-h3:!text-inherit*/}
      {/*            prose-span:!text-inherit*/}
      {/*    prose-h2:!text-inherit*/}
      {/*    prose-span:!text-inherit*/}
      {/*    `}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*  )}*/}
    </div>
  );
}
